import folderStore, { Folder } from 'owa-folders';
import { actionNames, MarkAllAsReadStoreUpdate } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { TableView } from 'owa-mail-list-store';

export default function markAllAsReadStitch() {
    // Refresh folder count when we refresh mail list
    subscribe<MarkAllAsReadStoreUpdate>(
        actionNames.MarkAllAsReadStoreUpdate,
        (tableView: TableView, markAsRead: boolean) => {
            const folderToMarkAsRead: Folder = folderStore.folderTable.get(
                tableView.serverFolderId
            );

            // Optimistic action
            // folderToMarkAsRead will be null in case of search folders
            if (folderToMarkAsRead != null) {
                folderToMarkAsRead.UnreadCount = markAsRead ? 0 : folderToMarkAsRead.TotalCount;
            }
        }
    );
}
